import { contract, getPageDataUrl } from '@aviv_price-pages/brand';
import HttpClient from '@/adapters/http/HttpClient';
import PlaceNotFoundError from '@/entities/errors/PlaceNotFoundError';
export const getPricePageProps = async (pathname) => {
    const pageDataPath = await getPageDataUrl(pathname, contract.i18n.defaultLocale);
    if (!pageDataPath) {
        throw new PlaceNotFoundError(pathname, new Error());
    }
    const url = `${process.env.BFF_BASE_URL || 'http://localhost:3001'}${pageDataPath}`;
    return HttpClient.getInstance().get(url, undefined, process.env.BFF_API_KEY);
};
